import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
interface Props {
  isCheck: boolean
  onChange: any
  errorLabel: string
}

class CheckBox extends Component<Props> {
  render() {
    const { isCheck, onChange, errorLabel } = this.props

    return (
      <Fragment>
        <Input
          errorLabel={errorLabel}
          type="checkbox"
          id="test1"
          checked={isCheck}
          onChange={onChange}
        />
        <Text htmlFor="test1" />
      </Fragment>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

export default CheckBox
//   border-color: ${props => (props.errorLabel ? '#D82C2C' : '#89919C')}; //'#e3e7ed' '#89919C'
// @ts-ignore
const Input = styled.input<IFormState>`
  //+ label:before: {
  //  border-color: green;
  //}
  :focus + label {
    border-color: ${props =>
      props.errorLabel ? '#D82C2C' : '#89919C'}!important;
  }
  :not(:checked),
  :checked {
    position: absolute;
    margin-top: 14px;
    left: -9999px;
  }
  :not(:checked) + label,
  :checked + label {
    position: relative;
    padding-left: 1.95em;
    cursor: pointer;
  }

  :not(:checked) + label:before,
  :checked + label:before {
    content: '';
    position: absolute;
    left: 0;
    //top: 0;
    margin-top: 10px;
    border-radius: 4px;
    border: 1px solid #e3e7ed;
    background-color: #f7f9fc;
    padding: 0.75rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #152735;
    background-clip: padding-box;
    transition: border-color 0.15s;
    box-sizing: border-box;
  }

  :not(:checked) + label:after,
  :checked + label:after {
    content: '\\2713\\0020';
    position: absolute;
    //top: 0.3em;
    margin-top: 14px;
    left: 0.2em;
    font-size: 1.5em;
    line-height: 0.8;
    color: #09ad7e;
    transition: all 0.2s;
    //font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
  }
  :not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  :checked + label:after {
    opacity: 1;
    transform: scale(1);
  }
  /* disabled checkbox */
  :disabled:not(:checked) + label:before,
  :disabled:checked + label:before {
    box-shadow: none;
    border-color: #bbb;
    background-color: #ddd;
  }
  :disabled:checked + label:after {
    color: #999;
  }
  :disabled + label {
    color: #aaa;
  }
  /* accessibility */
  + label:before {
    border-color: ${props => {
      console.log('props', props.errorLabel)
      return props.errorLabel ? '#D82C2C !important' : ''
    }}}; // #89919c;
    outline: 0;
  }
  :checked:focus + label:before,
  :not(:checked):focus + label:before {
    border-color: #89919c;
    outline: 0;
  }
  // :focus {
  //   border-color: ${props => (props.errorLabel ? '#D82C2C' : '#89919C')};
  //   outline: 0;
  // }
  //
  // border-color: ${props => props.errorLabel && '#D82C2C'};

  /* hover style just for information */
  //label:hover:before {
  //  border: 2px solid #4778d9 !important;
  //}
`

const Text = styled.label`
  :before {
    border-color: green;
  }
`